import Swiper from 'swiper/dist/js/swiper';
import './Tabs.scss';
// import throttleWheel from '../../throttle-wheel';

document.addEventListener('DOMContentLoaded', () => {
  $('[data-role*="tab-list-container"]').each((i, container) => {
    const bg = container.closest('.bg-dark');
    // const speed = 500;
    const swiper = new Swiper(container, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      mousewheel: {
        forceToAxis: true,
        invert: true,
        eventTarged: bg,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      slidesPerView: 1,
    });
    const $toggles = $(container).find('.tabs-header a');
    $toggles.each((ii, link) => {
      $(link).click((e) => {
        e.preventDefault();
        swiper.slideTo(ii);
        $toggles.removeClass('active');
        $(link).addClass('active');
      });
    });
    $toggles.eq(0).addClass('active');
    swiper.on('slideChange', () => {
      $toggles.removeClass('active');
      $toggles.eq(swiper.activeIndex).addClass('active');
    });

    // throttleWheel(container, speed);
  });
});
